<template>
  <div class="personal-info">
    <div class="image-container">
      <img class="image-intro" :src="require('@/assets/subscription/flow.png')">
    </div>

    <div class="form">
      <div class="title">היי {{ householdName }},</div>
      <div class="title">איזה כיף שממשיכים לצמוח יחד!</div>
      <div class="sub-title">נתחיל בקצת פרטים אישיים שרשומים אצלנו במערכת</div>
      <personal-info-form />
      <riseup-button class="riseup-button"
                     :action="() => next()"
                     :disabled="!personalInfoFieldsValid"
                     :title="'נמשיך לפרטים של הכרטיס'"/>
    </div>
    <div class="link" v-on:click="back">חזרה לתזרים שלך</div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';

import Segment from '../../../../../Segment';
import PersonalInfoForm from '../../navigation-pages/account-settings/components/PersonalInfoForm.vue';

export default {
  name: 'PersonalInfo',
  components: {
    PersonalInfoForm,
    RiseupButton: BaseUI.RiseupButton,
  },
  async created() {
    Segment.trackUserGot('SubscriptionPersonalInfoEntered');
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
    back: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapGetters('subscription', ['personalInfoFields']),
    ...mapState('subscription', ['personalInfo']),
    personalInfoFieldsValid() {
      return _.chain(this.personalInfo)
        .pick([this.personalInfoFields.firstName, this.personalInfoFields.lastName, this.personalInfoFields.phoneNumber])
        .every(field => field.isValid)
        .value();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../scss/mixins';

  .personal-info {
    .image-container {

      .image-intro {
        width: 100%;
      }
    }

    .form {
      @include responsive-padding;
      padding-top: 32px;
      padding-bottom: 32px;
      width: 100%;

      .title {
        @include title;
        line-height: 1;
      }

      .sub-title {
        padding: 12px 0 28px 28px;
        font-size: 20px;
        line-height: 1.3;
      }

      .riseup-button {
        width: 100%;
      }

      .field {
        padding-top: 5px;
      }
    }

    .link {
      padding-bottom: 34px;
      cursor: pointer;
      text-decoration: underline;
      color: $riseup_light_blue;
      text-align: center;
      font-weight: bold;
    }
  }
</style>
